/* eslint-disable @typescript-eslint/no-unsafe-argument */
/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable @typescript-eslint/no-dynamic-delete */
/* eslint-disable @typescript-eslint/no-unsafe-member-access */
import React, { useContext, useState, useEffect, useRef } from "react";
import {
  Badge,
  Button,
  Combobox,
  DatePicker,
  Input,
  Popover,
  PopoverContent,
  PopoverTrigger,
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuTrigger,
  DropdownMenuItem,
  Dialog,
  DialogContent,
  DialogHeader,
  DialogTitle,
  DialogDescription
} from "@repo/ui";
import { Link } from "react-router-dom";
import {
  CirclePlus,
  CircleX,
  LucideFileDigit,
  SlidersHorizontal
} from "lucide-react";
import {
  useGetCustomerCITList,
  useGetCustomers,
  useValidateBulkOrders
} from "utils/apis/lookups.api";
import {
  isOperationAllowed,
  onSealFileUploadPayload,
  readOnlyExcelDate,
  showToast
} from "utils/helper";
import { Permissions } from "utils/enums";
import { UserContext } from "utils/reducers/user";
import { saveFilters } from "utils/actions/user";

// @ts-expect-error react-excel-renderer ships without types
import { ExcelRenderer } from "react-excel-renderer";

// COLLECTIONS BULK API (for isSource===true)
import { useCreateBulkCollectionOrders } from "utils/apis/collections.api";
// DELIVERIES BULK API
import {
  useAssignBagSeals,
  useCreateBulkDeliveryOrders,
  useValidateBulkBagsAssignment
} from "utils/apis/deliveries.api";
import DownloadTemplate from "./download-template";
import { LookUpContext } from "utils/reducers/lookup";
// eslint-disable-next-line import/no-extraneous-dependencies
import { ExcelExport } from "@progress/kendo-react-excel-export";

export default function FilterBar({
  handleChangeFilter,
  setFilters,
  filters,
  onBtnCancelClicked,
  onBtnAssignRouteClicked,
  inRouteTeams,
  ddlInRouteTeams,
  setDdlInRouteTeams,
  isSource,
  isOnward,
  isCancel
}: {
  handleChangeFilter: (val: string, key: string) => void;
  setFilters: React.Dispatch<any>;
  filters: any;
  onBtnCancelClicked: () => void;
  onBtnAssignRouteClicked: () => void;
  inRouteTeams?: any[];
  ddlInRouteTeams: string;
  setDdlInRouteTeams: React.Dispatch<React.SetStateAction<string>>;
  isSource?: boolean;
  isOnward?: boolean;
  isCancel?: boolean;
}) {
  const { allBagTypes, coinContainers, currencies } = useContext(LookUpContext);
  const { dispatch, filters: contextFilers } = useContext(UserContext);
  const [openFileUpload, setOpenFileUpload] = useState(false);
  const [openSealFileUpload, setOpenSealFileUpload] = useState(false);
  const [sealAssignType, setSealAssignType] = useState("");
  const [fileReady, setFileReady] = useState(false);
  const [routesTeams, setRoutesTeams] = useState<any[]>([]);
  const [bagSealData, setBagSealData] = useState<any[]>([]);
  const routesTeamsList = useRef<any[]>([]);
  const fileInputRef = useRef<HTMLInputElement | null>(null);

  let excelExport1: ExcelExport | null;
  let excelExport2: ExcelExport | null;
  let excelExport3: ExcelExport | null;

  const {
    mutate: validateBulkOrders,
    isPending: validateOrdersPending,
    isSuccess: validateOrdersSuccess,
    data: validateData,
    isError: validateOrdersError,
    reset: validateReset
  } = useValidateBulkOrders();
  // COLLECTIONS mutation
  const {
    mutate: createBulkCollectionOrders,
    isPending: createCollectionPending,
    isSuccess: collectionSuccess,
    isError: collectionError,
    data: bulkCollectionResponseData
  } = useCreateBulkCollectionOrders();

  // DELIVERIES mutation
  const {
    mutate: createBulkDeliveryOrders,
    isPending: createDeliveryPending,
    isSuccess: deliverySuccess,
    isError: deliveryError,
    data: bulkDeliveryResponseData
  } = useCreateBulkDeliveryOrders();

  const {
    mutate: validateBulkBagsAssignment,
    isPending: validateBulkBagsAssignmentPending,
    isSuccess: validateBulkBagsAssignmentSuccess,
    isError: validateBulkBagsAssignmentError,
    reset: validateBagReset
  } = useValidateBulkBagsAssignment();
  // DELIVERIES mutation
  const {
    mutate: assignBagSeals,
    isPending: assignBagSealsPending,
    isSuccess: assignBagSealsSuccess,
    isError: assignBagSealsError,
    data: assignBagData
  } = useAssignBagSeals();

  const onDdlInRouteTeamsChanged = (value: string) => {
    if (!value) {
      setDdlInRouteTeams("");
      return;
    }
    setDdlInRouteTeams(value);
  };

  const { data: customers } = useGetCustomers();
  const { data: servicePoints } = useGetCustomerCITList(filters?.customer?.id);

  const handleClearFilter = (key: string) => {
    const updatedFilter = { ...filters };
    delete updatedFilter[key];
    setFilters({ ...updatedFilter });
    saveFilters(
      dispatch,
      isSource
        ? { ...contextFilers, collections: updatedFilter }
        : { ...contextFilers, deliveries: updatedFilter }
    );
  };

  const resetUploadState = (closeDialog = true) => {
    setRoutesTeams([]);
    routesTeamsList.current = [];
    setFileReady(false);
    validateReset();
    if (fileInputRef.current) fileInputRef.current.value = "";
    if (closeDialog) setOpenFileUpload(false);
  };

  const fileHandler = (event: any) => {
    const fileObj = event?.target?.files?.[0] as File | null;
    if (!fileObj) return;

    const supportedTypes = [
      "application/vnd.ms-excel",
      "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
      "csv",
      "text/csv"
    ];

    // Some browsers may not populate fileObj.type for CSV; allow by extension fallback
    const filename = (fileObj.name || "").toLowerCase();
    const extOk =
      filename.endsWith(".csv") ||
      filename.endsWith(".xls") ||
      filename.endsWith(".xlsx");

    if (!supportedTypes.includes(fileObj.type) && !extOk) {
      showToast("error", "File format not supported.");
      return;
    }

    routesTeamsList.current = [];

    ExcelRenderer(fileObj, (err: any, resp: any) => {
      if (err) {
        showToast("error", String(err));
        setFileReady(false);
        return;
      }
      const rows = resp?.rows || [];
      if (!rows.length) {
        showToast("error", "Excel file is empty.");
        setFileReady(false);
        return;
      }

      // parse each data row starting from 2nd row (index 1)
      for (let idx = 1; idx < rows.length; idx += 1) {
        const row = rows[idx] || [];
        // skip entirely empty rows
        const allEmpty = row.every(
          (c: any) => c === null || c === undefined || String(c).trim() === ""
        );
        if (allEmpty) continue;

        const sourceBarcode = row[0];
        const onwardBarcode = row[1];
        const serviceDate = row[2];
        const invoicingModel = row[3];
        const jobNature = row[4];
        const jobType = row[5];
        const priority = row[6];
        const routeNo = row[7];
        const requestedBy = row[8];
        // skip if  barcodes  is missing
        if (!sourceBarcode && !onwardBarcode) continue;

        routesTeamsList.current.push({
          sourceBarcode: String(sourceBarcode || "").trim(),
          onwardBarcode: String(onwardBarcode || "").trim(),
          serviceDate: readOnlyExcelDate(serviceDate),
          invoicingModel,
          priority,
          jobType,
          jobNature,
          routeNo,
          shift: "morning",
          requestedBy
        });
      }

      if (routesTeamsList.current.length > 0) {
        setRoutesTeams([...routesTeamsList.current]);
        setFileReady(true);
        validateBulkOrders([...routesTeamsList.current]);
      } else {
        showToast("error", "No valid data found in Excel file.");
        setFileReady(false);
      }
    }); // end ExcelRenderer
  }; // end fileHandler

  const onConfirmFileOrders = () => {
    if (!fileReady || !routesTeams.length) {
      showToast("error", "No parsed rows to upload.");
      return;
    }
    if (isSource) {
      // Collections: previous endpoint expects camelCase objects
      createBulkCollectionOrders(routesTeams);
    } else {
      // Deliveries: send objects with "SourceBarcode", "required cash", etc.
      createBulkDeliveryOrders(routesTeams);
    }
  };

  const onConfirmBagSeals = () => {
    assignBagSeals(bagSealData);
  };

  const onAssignSealModal = (type: string) => {
    setOpenSealFileUpload(true);
    setSealAssignType(type);
  };

  const onSealFileUpload = async (event: any) => {
    const payload = await onSealFileUploadPayload(
      event,
      sealAssignType,
      allBagTypes,
      coinContainers,
      currencies
    );
    setBagSealData(payload);
    validateBulkBagsAssignment(payload);
  };

  // close/reset on success/error for both endpoints
  useEffect(() => {
    if (collectionSuccess) {
      resetUploadState(true);
      showToast("success", "Bulk collection orders uploaded successfully.");
    }
    if (deliverySuccess) {
      resetUploadState(true);
      showToast("success", "Bulk delivery orders uploaded successfully.");
    }
    if (collectionError) {
      // react-query global interceptor may show details; fallback generic
      resetUploadState(true);
      showToast("error", "Failed to upload bulk collection orders.");
    }
    if (deliveryError) {
      resetUploadState(true);
      showToast("error", "Failed to upload bulk delivery orders.");
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [collectionSuccess, deliverySuccess, collectionError, deliveryError]);

  useEffect(() => {
    if (validateOrdersError || validateData) {
      resetUploadState(true);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [validateOrdersError, validateData]);

  useEffect(() => {
    if (validateBulkBagsAssignmentError) {
      setOpenSealFileUpload(false);
      if (fileInputRef.current) fileInputRef.current.value = "";
      setBagSealData([]);
      validateBagReset();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [validateBulkBagsAssignmentError]);

  useEffect(() => {
    if (assignBagSealsSuccess) {
      setOpenSealFileUpload(false);
      setBagSealData([]);
    }

    if (assignBagSealsError) {
      if (fileInputRef.current) fileInputRef.current.value = "";
      setBagSealData([]);
    }
  }, [assignBagSealsSuccess, assignBagSealsError]);

  useEffect(() => {
    if (assignBagData?.consignments?.length) {
      excelExport1?.save(assignBagData?.consignments);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [assignBagData]);

  useEffect(() => {
    if (validateOrdersError) {
      resetUploadState(true);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [validateOrdersError]);

  useEffect(() => {
    if (bulkDeliveryResponseData?.length) {
      excelExport2?.save(bulkDeliveryResponseData);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [bulkDeliveryResponseData]);

  useEffect(() => {
    if (validateOrdersSuccess) {
      createBulkCollectionOrders(routesTeams);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [validateOrdersSuccess]);

  useEffect(() => {
    if (bulkCollectionResponseData?.length) {
      excelExport3?.save(bulkCollectionResponseData);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [bulkCollectionResponseData]);

  return (
    <>
      <div className="flex gap-3">
        <Popover>
          <PopoverTrigger asChild>
            <Button variant="secondary" className="w-max" title="Apply Filters">
              <SlidersHorizontal />
            </Button>
          </PopoverTrigger>
          <PopoverContent align="start" className="w-[600px]">
            <h6 className="font-semibold text-lg">Apply Filters</h6>
            <div className="grid grid-cols-2 gap-4 mt-3">
              <Combobox
                placeholder="Select Customer"
                value={JSON.stringify(filters?.customer) || ""}
                data={customers?.map((item) => ({
                  value: JSON.stringify({
                    name: item.name,
                    id: item.customerId
                  }),
                  label: item.name
                }))}
                setValue={(val: string) => {
                  handleChangeFilter(val, "customer");
                }}
              />
              {isSource ? (
                <Combobox
                  placeholder="Select Location"
                  value={JSON.stringify(filters?.sourceSPId) || ""}
                  data={servicePoints?.map((item: any) => ({
                    value: JSON.stringify({
                      name: `${item.barcode}-${item.locationId}`,
                      id: item.servicePointId
                    }),
                    label: `${item.barcode}-${item.locationId}`
                  }))}
                  setValue={(val: string) => {
                    handleChangeFilter(val, "sourceSPId");
                  }}
                />
              ) : null}
              {isOnward ? (
                <Combobox
                  placeholder="Select Location"
                  value={JSON.stringify(filters?.sourceSPId) || ""}
                  data={servicePoints?.map((item: any) => ({
                    value: JSON.stringify({
                      name: `${item.barcode}-${item.locationId}`,
                      id: item.servicePointId
                    }),
                    label: `${item.barcode}-${item.locationId}`
                  }))}
                  setValue={(val: string) => {
                    handleChangeFilter(val, "sourceSPId");
                  }}
                />
              ) : null}
            </div>
          </PopoverContent>
        </Popover>

        <div className="max-w-[230px] w-full">
          <DatePicker
            placeholder="Select Operation Date"
            selectedDate={filters?.operationDate?.id || new Date()}
            onSelectDate={(date) => {
              handleChangeFilter(date as unknown as string, "operationDate");
            }}
          />
        </div>

        {isOperationAllowed(
          isSource ? Permissions.Collection : Permissions.Delivery,
          Permissions.Edit
        ) && (
          <div className="max-w-[230px] w-full">
            <Combobox
              setValue={onDdlInRouteTeamsChanged}
              value={ddlInRouteTeams}
              placeholder="Select Route"
              data={inRouteTeams?.map((item: any) => ({
                value: item?.routeNo,
                label: `${item.routeNo} (${item.description})`
              }))}
            />
          </div>
        )}

        <div className="flex-1 flex justify-end gap-2">
          {isOperationAllowed(
            isSource ? Permissions.Collection : Permissions.Delivery,
            Permissions.Add
          ) && (
            <DropdownMenu>
              <DropdownMenuTrigger asChild>
                <Button variant="secondary" className="gap-2">
                  <CirclePlus /> Create Request
                </Button>
              </DropdownMenuTrigger>
              <DropdownMenuContent className="w-[180px]">
                <DropdownMenuItem>
                  <Link
                    to={isSource ? "/create-collection" : "/create-delivery"}
                    state={{ createType: "single" }}
                  >
                    Single Request
                  </Link>
                </DropdownMenuItem>
                <DropdownMenuItem
                  onClick={() => {
                    setOpenFileUpload(true);
                  }}
                  className="cursor-pointer"
                >
                  Bulk Request
                </DropdownMenuItem>
              </DropdownMenuContent>
            </DropdownMenu>
          )}

          {isOperationAllowed(
            isSource ? Permissions.Collection : Permissions.Delivery,
            Permissions.Edit
          ) && (
            <Button variant="secondary" onClick={onBtnAssignRouteClicked}>
              Assign Route
            </Button>
          )}

          {isOnward && isOperationAllowed(Permissions.B2B, Permissions.Edit) ? (
            <DownloadTemplate operationDate={filters?.operationDate?.id} />
          ) : null}
          {isOnward && isOperationAllowed(Permissions.B2B, Permissions.Edit) ? (
            <DropdownMenu>
              <DropdownMenuTrigger asChild>
                <Button variant="secondary" className="gap-2">
                  <LucideFileDigit /> Bulk Bags Assignment
                </Button>
              </DropdownMenuTrigger>
              <DropdownMenuContent align="start" className="w-[180px]">
                <DropdownMenuItem
                  onClick={() => {
                    onAssignSealModal("Single Currency");
                  }}
                  className="cursor-pointer"
                >
                  Single Currency
                </DropdownMenuItem>
                <DropdownMenuItem
                  onClick={() => {
                    onAssignSealModal("AED Coins");
                  }}
                  className="cursor-pointer"
                >
                  AED Coins
                </DropdownMenuItem>
                <DropdownMenuItem
                  onClick={() => {
                    onAssignSealModal("Foreign Currency");
                  }}
                  className="cursor-pointer"
                >
                  Foreign Currency
                </DropdownMenuItem>
              </DropdownMenuContent>
            </DropdownMenu>
          ) : null}
          {/* {isOperationAllowed(
            isSource ? Permissions.Collection : Permissions.Delivery,
            Permissions.Cancel,
          ) && ( */}
          <Button
            variant="secondary"
            disabled={isCancel}
            onClick={onBtnCancelClicked}
          >
            Cancel
          </Button>
          {/* // )} */}
        </div>
      </div>

      <div className="flex mt-3 gap-2 flex-wrap items-end">
        {Object.entries(filters as object).map(
          ([key, val]: [string, { name: string; id: string }]) => (
            <Badge
              variant="secondary"
              className="gap-3 pr-1 cursor-pointer"
              key={key}
            >
              {val.name}{" "}
              <CircleX
                onClick={() => {
                  handleClearFilter(key);
                }}
              />
            </Badge>
          )
        )}
      </div>
      <div className="border-b mt-3 mb-2 bg-accent" />

      {isOperationAllowed(
        isSource ? Permissions.Collection : Permissions.Delivery,
        Permissions.Search
      ) && (
        <div className="ml-auto max-w-[420px] w-full">
          <Input
            value={filters?.search?.id}
            onChange={(e) => {
              handleChangeFilter(e.target.value, "search");
            }}
            title="Search: Job No., Job Nature, Status, Route No."
            placeholder="Search: Job No., Job Nature, Status, Route No."
          />
        </div>
      )}

      <ExcelExport
        ref={(exporter) => {
          excelExport1 = exporter;
        }}
        fileName={`Delivery_Bags_Assignment_${new Date().toLocaleString()}.xlsx`}
        columns={[
          { field: "serviceDate", title: "Service Date" },
          { field: "routeNo", title: "Route No" },
          { field: "sourceBarcode", title: "Source Barcode" },
          { field: "onwardBarcode", title: "Onward Barcode" },
          { field: "sealNo", title: "Seal No" },
          { field: "containerType", title: "Bag Type" },
          { field: "currency", title: "Currency" },
          { field: "declaredValue", title: "Value" },
          { field: "denominations", title: "Coins Denomination" },
          { field: "denomination", title: "Note Denomination" },
          { field: "count", title: "Count" },
          { field: "assigmentStatus", title: "Status" },
          { field: "locationId", title: "Location ID" }
        ]}
      />
      <ExcelExport
        ref={(exporter) => {
          excelExport2 = exporter;
        }}
        fileName={`Delivery_Bulk_Orders_${new Date().toLocaleString()}.xlsx`}
        columns={[
          { field: "sourceBarcode", title: "Source Barcode" },
          { field: "onwardBarcode", title: "Onward Barcode" },
          { field: "serviceDate", title: "Service Date" },
          { field: "invoicingModel", title: "Invoicing Model" },
          { field: "jobType", title: "Job Type" },
          { field: "jobNature", title: "Job Nature" },
          { field: "routeNo", title: "Route No" },
          { field: "requestedBy", title: "Requested By" },
          { field: "status", title: "Status" },
          { field: "message", title: "Message" }
        ]}
      />
      <ExcelExport
        ref={(exporter) => {
          excelExport3 = exporter;
        }}
        fileName={`Collection_Bulk_Orders_${new Date().toLocaleString()}.xlsx`}
        columns={[
          { field: "sourceBarcode", title: "Source Barcode" },
          { field: "onwardBarcode", title: "Onward Barcode" },
          { field: "serviceDate", title: "Service Date" },
          { field: "invoicingModel", title: "Invoicing Model" },
          { field: "jobType", title: "Job Type" },
          { field: "jobNature", title: "Job Nature" },
          { field: "routeNo", title: "Route No" },
          { field: "requestedBy", title: "Requested By" },
          { field: "status", title: "Status" },
          { field: "message", title: "Message" }
        ]}
      />
      {/* Bulk Orders Upload Dialog */}
      <Dialog open={openFileUpload} onOpenChange={setOpenFileUpload}>
        <DialogContent>
          <DialogHeader>
            <DialogTitle>
              {isSource ? "Upload Collection Orders" : "Upload Delivery Orders"}
            </DialogTitle>
          </DialogHeader>
          <DialogDescription className="pt-6">
            {fileReady ? (
              <div className="flex flex-col items-center justify-center py-5">
                <p className="mb-2 text-gray-500 dark:text-gray-400">
                  File parsed successfully!{" "}
                  <strong>{routesTeams.length}</strong> rows ready.
                </p>
                <div className="flex gap-2">
                  <Button
                    variant="secondary"
                    onClick={onConfirmFileOrders}
                    isLoading={
                      validateOrdersPending ||
                      createCollectionPending ||
                      createDeliveryPending
                    }
                    disabled={
                      !validateOrdersSuccess ||
                      createCollectionPending ||
                      createDeliveryPending
                    }
                  >
                    Add orders
                  </Button>
                  <Button
                    variant="ghost"
                    onClick={() => {
                      // allow re-upload / choose another file
                      resetUploadState(false);
                      setOpenFileUpload(true);
                    }}
                  >
                    Choose another file
                  </Button>
                </div>
              </div>
            ) : (
              <label
                htmlFor="dropzone-file"
                className="flex flex-col items-center justify-center w-full h-64 border-2 border-gray-300 border-dashed rounded-lg cursor-pointer bg-gray-50 hover:bg-gray-100 dark:border-gray-600 dark:hover:border-gray-500 dark:hover:bg-gray-600"
              >
                <span className="sr-only">Upload file</span>
                <div className="flex flex-col items-center justify-center pt-5 pb-6">
                  <svg
                    className="w-8 h-8 mb-4 text-gray-500 dark:text-gray-400"
                    aria-hidden="true"
                    xmlns="http://www.w3.org/2000/svg"
                    fill="none"
                    viewBox="0 0 20 16"
                  >
                    <path
                      stroke="currentColor"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      strokeWidth="2"
                      d="M13 13h3a3 3 0 0 0 0-6h-.025A5.56 5.56 0 0 0 16 6.5 5.5 5.5 0 0 0 5.207 5.021C5.137 5.017 5.071 5 5 5a4 4 0 0 0 0 8h2.167M10 15V6m0 0L8 8m2-2 2 2"
                    />
                  </svg>
                  <p className="mb-2 text-sm text-gray-500 dark:text-gray-400">
                    <span className="font-semibold">Click to upload</span> or
                    drag and drop
                  </p>
                  <p className="text-xs text-gray-500 dark:text-gray-400">
                    XLS, XLSX, CSV (MAX. 5GB)
                  </p>
                </div>
                <input
                  ref={fileInputRef}
                  id="dropzone-file"
                  accept=".xlsx, .xls, .csv"
                  type="file"
                  className="hidden"
                  onChange={fileHandler}
                />
              </label>
            )}
          </DialogDescription>
        </DialogContent>
      </Dialog>

      {/* Assign Seal Orders */}

      <Dialog
        open={openSealFileUpload}
        onOpenChange={() => {
          setBagSealData([]);
          setOpenSealFileUpload(false);
        }}
      >
        <DialogContent>
          <DialogHeader>
            <DialogTitle>{sealAssignType} Per Bag</DialogTitle>
          </DialogHeader>
          <DialogDescription className="pt-6">
            {bagSealData.length ? (
              <div className="flex flex-col items-center justify-center py-5">
                <p className="mb-2 text-gray-500 dark:text-gray-400">
                  File parsed successfully!{" "}
                  <strong>{bagSealData.length}</strong> rows ready.
                </p>
                <div className="flex gap-2">
                  <Button
                    variant="secondary"
                    onClick={onConfirmBagSeals}
                    isLoading={
                      validateBulkBagsAssignmentPending || assignBagSealsPending
                    }
                    disabled={
                      !validateBulkBagsAssignmentSuccess ||
                      assignBagSealsPending
                    }
                  >
                    Assign Seals
                  </Button>
                  <Button
                    variant="ghost"
                    onClick={() => {
                      if (fileInputRef.current) fileInputRef.current.value = "";
                      setBagSealData([]);
                    }}
                  >
                    Choose another file
                  </Button>
                </div>
              </div>
            ) : (
              <label
                htmlFor="dropzone-file"
                className="flex flex-col items-center justify-center w-full h-64 border-2 border-gray-300 border-dashed rounded-lg cursor-pointer bg-gray-50 hover:bg-gray-100 dark:border-gray-600 dark:hover:border-gray-500 dark:hover:bg-gray-600"
              >
                <span className="sr-only">Upload file</span>
                <div className="flex flex-col items-center justify-center pt-5 pb-6">
                  <svg
                    className="w-8 h-8 mb-4 text-gray-500 dark:text-gray-400"
                    aria-hidden="true"
                    xmlns="http://www.w3.org/2000/svg"
                    fill="none"
                    viewBox="0 0 20 16"
                  >
                    <path
                      stroke="currentColor"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      strokeWidth="2"
                      d="M13 13h3a3 3 0 0 0 0-6h-.025A5.56 5.56 0 0 0 16 6.5 5.5 5.5 0 0 0 5.207 5.021C5.137 5.017 5.071 5 5 5a4 4 0 0 0 0 8h2.167M10 15V6m0 0L8 8m2-2 2 2"
                    />
                  </svg>
                  <p className="mb-2 text-sm text-gray-500 dark:text-gray-400">
                    <span className="font-semibold">Click to upload</span> or
                    drag and drop
                  </p>
                  <p className="text-xs text-gray-500 dark:text-gray-400">
                    XLS, XLSX, CSV (MAX. 5GB)
                  </p>
                </div>
                <input
                  ref={fileInputRef}
                  id="dropzone-file"
                  accept=".xlsx, .xls, .csv"
                  type="file"
                  className="hidden"
                  // eslint-disable-next-line @typescript-eslint/no-misused-promises
                  onChange={onSealFileUpload}
                />
              </label>
            )}
          </DialogDescription>
        </DialogContent>
      </Dialog>
    </>
  );
}
